import { render, staticRenderFns } from "./KasaIzbornik.vue?vue&type=template&id=32f7c080&scoped=true"
import script from "./KasaIzbornik.vue?vue&type=script&lang=js"
export * from "./KasaIzbornik.vue?vue&type=script&lang=js"
import style0 from "./KasaIzbornik.vue?vue&type=style&index=0&id=32f7c080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f7c080",
  null
  
)

export default component.exports